//------------------------------------------------------ externos
import { useState } from "react";
//------------------------------------------------------ elementos
//------------------------------------------------------ funciones
import Button from "../../buttons/Button";
import FormTractor from "../../formularios/FormTractor";
import FormFurgon from "../../formularios/FormFurgon";
import FormVehiculo from "../../formularios/FormVehiculo";

const MovimientoVehiculoAccess = ({ tipo = "vehiculo" }) => {
  const TITLE = `${tipo.toUpperCase() || "VEHICULO"}`;
  const [formVisible, setFormVisible] = useState(false);

  const forms = {
    tractor: FormTractor,
    furgon: FormFurgon,
    vehiculo: FormVehiculo,
  };
  // El icono sale del TIPO, igual que el formulario. Son nombres del set de
  // `Icono.jsx`, no rutas: cambiar el dibujo mañana no toca este archivo.
  const iconos = { tractor: "camion", furgon: "furgon", vehiculo: "auto" };

  const SelectedForm = forms[tipo] || FormVehiculo;
  const icono = iconos[tipo] || "auto";
  const handleOpen = () => {
    setFormVisible(true);
  };

  const handleClose = () => {
    setFormVisible(false);
  };

  return (
    <>
      <Button
        text={TITLE}
        onClick={handleOpen}
        icono={icono}
        plus={true}
      />

      {formVisible && (
        <SelectedForm onGuardar={handleClose} onClose={handleClose} />
      )}
    </>
  );
};

export default MovimientoVehiculoAccess;
